import React from "react";
import { css } from "@emotion/react";
import consulting from "@src/assets/expert/consulting.png";
import writingFace from "@src/assets/expert/writingFace.png";
import {
    noticeContainerStyle,
    TitleStyle,
    ContentContainerStyle,
    BlueBoxStyle,
    BlueTitleStyle,
    BlackTitleStyle,
    BlackStepStyle,
    DarkGreyContentStyle,
    dividerStyle,
} from "./TakerAgentNotice";

const TakerAccompanyNotice = () => {
    return (
        <div css={noticeContainerStyle}>
            <div css={TitleStyle}>
                임장동행 <br />
                <span style={{ fontWeight: "normal", fontSize: "18px" }}>서비스 이렇게 진행돼요!</span>
            </div>
            <div css={ContentContainerStyle}>
                {/* Step1 */}
                <div className="stepBox">
                    <img src={consulting} alt="consulting" className="stepIcon" width={50} height={50} />
                    <p css={BlackTitleStyle}>
                        <span css={BlackStepStyle}>step.01</span> 임장동행
                    </p>
                    <div css={BlueBoxStyle}>
                        <p css={BlueBoxDescStyle}>의뢰인에게 임장동행을 제공해요.</p>
                        <p css={CostTextStyle}>✔️ 임장동행 비용 : 22만원</p>
                        <div css={dividerStyle} style={{ margin: "0 0 14px 0" }} />
                        <div css={NumberedListStyle}>
                            <div css={NumberedItemStyle}>
                                <div css={BlueCircleStyle}>1</div>
                                <div>
                                    <p css={BlueTitleStyle}>임장동행 요청 받기</p>
                                    <p css={ItemDescStyle}>
                                        전국에 있는 전문가는 빠르게 의뢰인이 보낸 임장동행 매칭 요청을 받아요.
                                    </p>
                                </div>
                            </div>
                            <div css={NumberedItemStyle}>
                                <div css={BlueCircleStyle}>2</div>
                                <div>
                                    <p css={BlueTitleStyle}>지원하기</p>
                                    <p css={ItemDescStyle}>
                                        전문가는 받은 임장동행 매칭에 지원 할수 있고, 의뢰인은 응답한 전문가의 채팅 및 프로필을
                                        통해 직접 선택할 수 있어요.
                                    </p>
                                </div>
                            </div>
                            <div css={NumberedItemStyle}>
                                <div css={BlueCircleStyle}>3</div>
                                <div>
                                    <p css={BlueTitleStyle}>매칭 완료</p>
                                    <p css={ItemDescStyle}>
                                        의뢰인이 임장동행 전문가 목록 중 한명을 선택해 임장동행 전문가로 지정하면 매칭이 완료돼요.
                                    </p>
                                </div>
                            </div>
                            <div css={NumberedItemStyle}>
                                <div css={BlueCircleStyle}>4</div>
                                <div>
                                    <p css={BlueTitleStyle}>임장동행 제공</p>
                                    <p css={ItemDescStyle}>
                                        의뢰인과 함께 현장을 방문하여, 물건 상태를 점검하고 필요한 정보를 제공해요.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Step2 */}
                <div className="stepBox">
                    <img src={writingFace} alt="writingFace" className="stepIcon" width={50} height={50} />
                    <p css={BlackTitleStyle}>
                        <span css={BlackStepStyle}>Step.02</span> 후기 확인
                    </p>
                    <p css={DarkGreyContentStyle} style={{ marginTop: "14px", fontSize: "12px" }}>
                        담당한 의뢰인이 작성한 후기를 확인할 수 있어요. 정산 금액은 의뢰인이 완료한 후 3일 이내 [내정보]에 입력한
                        전문가 계좌로 지급돼요. (의뢰인이 완료하지 않을 경우 14일 이내 자동 완료 처리돼요.)
                    </p>
                </div>
            </div>
        </div>
    );
};

export default TakerAccompanyNotice;

const BlueBoxDescStyle = css`
    color: #382e51;
    font-size: 12px;
    font-weight: bold;
    line-height: 1.4;
`;

const CostTextStyle = css`
    color: #3c3c3c;
    font-size: 12px;
    line-height: 1.4;
    margin-top: 14px;
    margin-bottom: 6px;
`;

const NumberedListStyle = css`
    display: flex;
    flex-direction: column;
    gap: 14px;
`;

const NumberedItemStyle = css`
    display: flex;
    gap: 6px;
    align-items: flex-start;
`;

const BlueCircleStyle = css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    min-width: 16px;
    background-color: #2275ee;
    border-radius: 1000px;
    color: white;
    font-size: 11px;
    font-weight: bold;
    margin-top: 2px;
`;

const ItemDescStyle = css`
    color: #8d8d8d;
    font-size: 12px;
    line-height: 1.4;
    margin-top: 8px;
`;
